module.exports = __webpack_public_path__ + "img/polyester.be5030ca.webp";